import { getMaterialDecision, PredictionWithApproval } from './materialDecision';

export interface ReadinessInput {
  selectedImageIndex: number | null;
  isImageTimedOut: boolean;
  isImageFetched: boolean;
  isNoImageCorrect: boolean;
  materialApproval: PredictionWithApproval;
}

export function getIsReady({
  selectedImageIndex,
  isImageTimedOut,
  isImageFetched,
  isNoImageCorrect,
  materialApproval,
}: ReadinessInput): boolean {
  // no image selected, and still waiting for one (or the image timeout) to resolve that
  const hasImageOutcome = selectedImageIndex !== null || isImageTimedOut;
  if (!hasImageOutcome) return false;

  // user said none of the images matched -> only the manual material pick matters
  if (isNoImageCorrect) return materialApproval.selectedValue !== null;

  // still waiting for the selected image's data (or its timeout) to resolve
  const hasImageData = isImageFetched || isImageTimedOut;
  if (!hasImageData) return false;

  // still waiting for a material prediction (or explicit "none available")
  if (materialApproval.predictedValue === undefined) return false;

  // a decision is only complete once it resolves to an actual material, whether predicted or picked manually
  return getMaterialDecision(materialApproval).selectedMaterial !== null;
}
